module.exports = __webpack_public_path__ + "sol.png?0561326eab0d4627d68be2bb83639768";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sol.png
// module id = 262
// module chunks = 0